import './message.sass';

export { default } from './message';
